import { deflate as pakoDeflate } from 'pako/dist/pako_deflate';

export var deflate = pakoDeflate;

export function supportsDeflate() {
    return true;
}




//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/pdf/deflate.js
// module id = ../../../../@progress/kendo-drawing/dist/es/pdf/deflate.js
// module chunks = vendor